export const parse = (obj: null | undefined | string) =>
  JSON.parse(obj || "{}");
